import { Component, h } from 'preact'
import Table from '../table/Table'
import ButtonControl from '../button-control'
import UserAvatar from '../User/UserAvatar'
import { Member } from './GroupEdit'
import axios from 'axios'
import EmptyPage from '../empty-page/EmptyPage'
import formatDateInLocalTimezone from '../utils/dateFormatting'

interface Props {
  groupId: number,
  defaultCdn: string
}

interface State {
  applications: null | Array<Member>
}

export class GroupApplications extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      applications: null
    }

    this.approveUser = this.approveUser.bind(this)
    this.declineUser = this.declineUser.bind(this)
    this.setNewApplicantList = this.setNewApplicantList.bind(this)

    let element: HTMLInputElement | null = document.querySelector('input#csrftoken')

    if (element !== null) {
      this.csrf = element.value
    }
  }

  csrf: string = ''

  setNewApplicantList (userId: number) {
    const idx = (this.state.applications || []).findIndex(applicant => applicant.id === userId)
    const newList: Array<Member> = (this.state.applications || []).concat([])
    newList.splice(idx, 1)
    this.setState({ applications: newList })
  }

  async approveUser (userId: number) {
    await axios.post(`/platform/group/${this.props.groupId}/applicants/${userId}`, { csrfToken: this.csrf })
    this.setNewApplicantList(userId)
  }

  async declineUser (userId: number) {
    await axios.delete(`/platform/group/${this.props.groupId}/applicants/${userId}`, { data: { csrfToken: this.csrf } })
    this.setNewApplicantList(userId)
  }

  async componentDidMount () {
    const response = await axios.get(`/platform/group/${this.props.groupId}/applicants`)
    if (response.data) {
      this.setState({
        applications: response.data
      })
    }
  }

  render ({ defaultCdn }: Props, { applications }: State) {
    const model = [{
      header: 'User',
      accessor: 'title'
    }, {
      header: 'Rank title',
      accessor: 'rank_title'
    }, {
      header: 'Applied time',
      accessor: 'applied_time'
    }, {
      header: 'Actions',
      accessor: 'actions'
    }]
    const rows = (applications || []).map((userWaitingApproval: Member) => (
      {
        title: <div className='user-info'>
          <div className='user-info_avatar'>
            <UserAvatar user={{ ...userWaitingApproval, name: userWaitingApproval.username }} openInNewTab style={{ width: '40px', height: '40px' }} />
          </div>
          <div className='user-info_username-email'>
            <div className='user-info_username'>
              { userWaitingApproval.username }
            </div>
            <div className='user-info_email'>{ userWaitingApproval.email }</div>
          </div>
        </div>,
        rank_title: <div>{ userWaitingApproval.rank || '-' }</div>,
        applied_time: <div>{ formatDateInLocalTimezone(userWaitingApproval.applied_time) }</div>,
        actions: <div>
          <ButtonControl title='Approve' variant='secondary' onClick={() => this.approveUser(userWaitingApproval.id)} />
          <ButtonControl title='Decline' variant='warning' onClick={() => this.declineUser(userWaitingApproval.id)} />
        </div>
      }
    ))

    if (applications === null) {
      return null
    }

    return (
      <div className='group-users-waiting-for-approval-tab'>
        {
          applications.length ? (
            <div>
              <div className='group-users-management_header'>
                <strong>Applications ({applications.length})</strong>
              </div>
              <Table model={model} rows={rows} narrow />
            </div>
          ) : (
            <EmptyPage
              img_src={`${defaultCdn}/images/empty_group_applications.png`}
              header='All done!'
              text={'You’ve processed all the new applications'}
              button={{ link: '/platform/groups', text: 'Back to overview' }}
            />
          )
        }
      </div>
    )
  }
}

export default GroupApplications
